"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsPresentationButton", function(obsPresentationPopin) {
    return {
        restrict     : "E",
        scope        : true,
        replace      : true,
        template     : require("./obsPresentationButton.html"),
        link : function($scope, $el, $attrs) {

            $scope.openPresentationPopin = function() {
                obsPresentationPopin.open();
            };

        }
    };
});

ngModule.factory("leafletPresentationButton", function($rootScope, leaflet, directiveUtils) {

    leaflet.Control.ObsPresentationButton = leaflet.Control.extend({

        options: {
            position: 'topleft'
        },

        onAdd : function(map) {
            var linkFn = directiveUtils.compileDirective("obsPresentationButton");
            var watermark = linkFn($rootScope);
            return watermark[0];
        }

    });

    return leaflet.Control.ObsPresentationButton;
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/obsPresentationButton.js